import store, { registerStoreModuleAsync } from 'Store';

async function registerStoreModulePrimaryOfferings() {
  const { default: storeModule } = await import(/* webpackChunkName: 'storeModulePrimaryOfferings' */ '../store');
  if (!store.hasModule('primary-offerings')) {
    store.registerModule('primary-offerings', storeModule);
  }
}

async function registerStoreModules(to, from, next) {
  const promises = [];
  promises.push(registerStoreModulePrimaryOfferings());
  promises.push(registerStoreModuleAsync('account'));
  await Promise.all(promises);
  next();
}

export default [
  {
    path: '/investments/primary-offerings',
    name: 'primary-offerings',
    component: () => import(/* webpackChunkName: 'PagePrimaryOfferings' */ '../PagePrimaryOfferings'),
    beforeEnter: registerStoreModules,
    meta: {
      resolve() {
        if (store.getters['login/isLoggedIn']) store.dispatch('account/loadAccountListOnce');
      },
      store: [
        'farm/getList',
        'farm/getClosedSuccessfullyList',
        'page/getPageData',
        'primary-offerings/getExitedList',
        'primary-offerings/getPendingClosingList',
      ],
    },
  },
];
